import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/features/ebooks/EbooksPage.jsx");
